import React, { useState } from 'react'
import { Dialog, DialogTrigger } from 'react-aria-components'
import { useTranslation } from 'react-i18next'

import type { SearchIngredient } from '@/api/types'
import { Button } from '@/components/Button'
import { Modal, ModalHeader } from '@/components/Modal'
import FCDBIngredientsContent from './FCDBIngredientsContent'

type Props = {
  selection: SearchIngredient[]
  onChangeSelection(selection: SearchIngredient[]): void
}

export default function FCDBIngredientSelector({ selection, onChangeSelection }: Props) {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <DialogTrigger>
      <Button onPress={() => setIsOpen(true)}>{t('ingredient.addFcdbIngredients')}</Button>
      <Modal isOpen={isOpen} style={{ height: '90vh', maxHeight: '90vh' }}>
        <Dialog>
          {({ close }) => (
            <>
              <ModalHeader onClose={close}>{t('ingredient.fcdbIngredients')}</ModalHeader>
              <FCDBIngredientsContent
                selection={selection}
                onChangeSelection={onChangeSelection}
                close={close}
              />
            </>
          )}
        </Dialog>
      </Modal>
    </DialogTrigger>
  )
}
